//xs small sizes of 8x10, 10x8 and 10x10 do not sell online
export const sizeMap = {
  xss: `10"x10"`, //extra-small square
  xsv: `8"x10"`, //extra-small vertical
  xsh: `10"x8"`, //extra-small horizontal
  ss: `14"x14"`, //small square
  sv: `11"x14"`, //small vertical
  sh: `14"x11"`, //small horizontal
  ms: `16"x16"`, //medium square
  mv: `12"x16"`, //medium vertical
  mh: `16"x12"`, //medium horizontal
  ls: `20"x20"`, //large square
  lv: `16"x20"`, //large horizontal
  lh: `20"x16"`, //large vertical
  postcard1: `4"x6"`, //postcard small
  //TODO: should change the value below to large postcard
  postcard2: `4.5"x6.5"`,
};
